function isPureNumber(val) {
  return /^[0-9]+$/.test(val)
}

export const CHINESE_NAME_STR = 'chineseName'
export const NAME_STR = 'name'
export const EMPLOYEE_NUMBER_STR = 'employeeNumber'


export const EMPLOYEE_URL_MAP = {
  hr: {
    url: 'hr.employee.refactoring.listExSensitive',
    formatParams: (val, inputLength, params) => {
      const { status, ...resetParams } = params || {}
      let obj = {
        nameOrNumber: val,
        inOffice: +status, // 这里是区分在职还是离职
        ...resetParams
      }
      if (status === '0') {
        delete obj.inOffice
      }
      return obj
    },
    valueKey: NAME_STR,
    filterResult: (result = []) => {
      const filterData = [
        ...result.map(it => ({
          ...it,
          optionDisabled: it.inOffice === 20
        }))
      ]
      filterData.sort((a, b) => a.inOffice - b.inOffice)
      return filterData
    },
    renderKeys: ['name', 'duty', 'department', 'employeeNumber']
  },
  data: {
    url: 'data.employee.listByName',
    valueKey: CHINESE_NAME_STR,
    formatParams: (val, inputLength = 2, {status}) => {
      if (!val || val.length < inputLength) return
      const isNumber = isPureNumber(val)
      const params = {
        status, // 这里是区分在职还是离职
        [isNumber ? EMPLOYEE_NUMBER_STR : CHINESE_NAME_STR]: val
      }
      if (status === '0') {
        delete params.status
      }
      return params
    },
    filterResult: (result = []) => {
      const filterData = [
        ...result.map(it => ({
          ...it,
          optionDisabled: it.status === '20'
        }))
      ]
      filterData.sort((a, b) => +a.status - +b.status)
      return filterData
    },
    renderKeys: ['chineseName', 'position', 'departmentName', 'employeeNumber']
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-employee/utils/api.js